module.exports = __webpack_public_path__ + "static/media/header-logo.fe6457fb.png";